import { render, staticRenderFns } from "./PropertyCompanyMergeModal.vue?vue&type=template&id=2d7f5ba6"
import script from "./PropertyCompanyMergeModal.vue?vue&type=script&lang=js"
export * from "./PropertyCompanyMergeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports